// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper__GT-at","header":"Card_header__14c42","headerNumber":"Card_headerNumber__18Kxr","title":"Card_title__3wAjc","content":"Card_content__32-OA"};